module.exports = __webpack_public_path__ + "img/Bag.8910ab16.svg";